import type { FC } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

import type { MultiSelectFilterConfig } from './filter-types';
import { FilterOption } from './FilterOption';
import { useFilterItemStyles } from './use-filter-item-styles';

interface Props {
  multiSelectFilterConfig: MultiSelectFilterConfig;
  selectedValues: string[];
}

export const MultiSelectFilter: FC<Props> = ({
  multiSelectFilterConfig,
  selectedValues,
}) => {
  const classes = useFilterItemStyles();
  const {
    icon,
    title,
    subtitle,
    keyOptions: filterOptions,
    key,
    onUpdate,
  } = multiSelectFilterConfig;

  const handleToggle = (value: string) => {
    const currentValues = selectedValues || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];

    onUpdate({ [key]: newValues });
  };

  return (
    <Box className={classes.item} key={title + key}>
      <FilterOption icon={icon} title={title} subtitle={subtitle}>
        {filterOptions.map(({ label, value, color }, index) => (
          <Box key={label + index}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedValues?.includes(value || '') || false}
                  onChange={() => handleToggle(value || '')}
                  size="small"
                  sx={{
                    color: color ? `rgba(${color})` : 'primary.main',
                    '&.Mui-checked': {
                      color: color ? `rgba(${color})` : 'primary.main',
                    },
                  }}
                />
              }
              label={label}
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                },
              }}
            />
          </Box>
        ))}
      </FilterOption>
    </Box>
  );
};
